export default {
  reviewCompleteHeader: 'Tinjau dan Selesaikan',
  participants: 'Peserta',
  enterParticipantInfoText:
    'Silakan masukkan detail yang diperlukan untuk melanjutkan ke pembayaran.',
  purchaser: 'Pembeli',
  firstName: 'Nama Depan',
  lastName: 'Nama Belakang',
  email: 'Email',
  optionalEmail: 'Email: (opsional)',
  'phone:': 'Telepon',
  participantFieldPlaceholder: 'Tambah baru atau pilih peserta yang ada',
  reservationSummary: 'Ringkasan Reservasi',
  editParticipantsDetails: 'Edit Detail Peserta',
  participantDetails: 'Detail',
  duplicatePurchaserText: 'Sama dengan Pembeli',
  phone: 'Telepon',
  addParticipant: 'Tambahan {{tierLabel}}',
  participant: 'Peserta',
  removeParticipant: 'Hapus',
  experienceCheckoutCompleted: 'Pembayaran Pengalaman Selesai',
  experienceCartCheckout: 'Pembayaran Keranjang Pengalaman',
  experienceLimitReached:
    'Maaf, pengalaman ini telah mencapai jumlah peserta maksimal',
  payment: 'Pembayaran',
  duration: 'Durasi',
  discountCode: 'Kode Diskon',
  removeCode: 'Hapus Kode',
  invalidCodeValidation: 'Kode Kupon Tidak Valid',
  networkErrorDiscountCode: 'Terjadi kesalahan di pihak kami',
  onlyOneCouponCodeAllowed: 'Hanya satu kode kupon yang diperbolehkan',
  creditCodeHasAlreadyBeenApplied: 'Kode kredit sudah diterapkan',
  discount: 'Diskon',
  promo: 'Promo',
  promoCode: 'Kode promo',
  apply: 'Terapkan',
  total: 'Total',
  subTotal: 'Subtotal',
  includes: 'Termasuk',
  and: 'dan',
  addHostNotes: 'Tambahkan catatan untuk tuan rumah Anda',
  brandAggreementText:
    'Saya menyetujui, atau saya menyatakan bahwa saya berwenang atas nama peserta untuk menyetujui, syarat dan ketentuan dari',
  termsAggreementValidation: 'Silakan setujui syarat dan ketentuan',
  firstNameValidation: 'Nama Depan wajib diisi',
  lastNameValidation: 'Nama Belakang wajib diisi',
  emailValidation: {
    emailRequiredText: 'Email wajib diisi',
    invalidEmail: 'Alamat Email Tidak Valid',
    not_specified: 'Alamat Email Salah',
  },
  phoneValidation: {
    'Invalid Phone Number': 'Nomor Telepon Tidak Valid',
    not_specified: 'Tidak Valid',
    phoneRequiredText: 'Nomor telepon wajib diisi',
  },
  participantFirstNameValidation: 'Nama Depan Peserta wajib diisi',
  participantLastNameValidation: 'Nama Belakang Peserta wajib diisi',
  complete: 'Selesai',
  '404Message': 'Tidak Ditemukan',
  waiting: 'Menunggu...',
  complimentary: 'Gratis',
  confirmationHeader: 'Pengalaman Anda telah dipesan!',
  confirmationText:
    'Email konfirmasi telah dikirim ke {{email}} dengan detail tambahan',
  viewAll: 'Lihat semua Pengalaman',
  paymentMethod: 'Metode Pembayaran',
  creditCard: 'Kartu Kredit',
  roomCharge: 'Tagihan Kamar',
  memberCharge: 'Tagihan Anggota',
  roomOrReservationNumber: 'Nomor Kamar atau Nomor Konfirmasi',
  roomNumber: 'Nomor Kamar',
  roomNumberLegacy: 'Nomor Kamar / Kode Konfirmasi',
  memberNumber: 'Nomor Anggota',
  kicc: 'Easy Pay',
  chargeValidation: 'Nomor Kamar dan Nama belakang wajib diisi',
  memberNumberValidation: 'Nomor Anggota wajib diisi',
  invalidRoomNumber: 'Nomor kamar tidak valid',
  invalidRoomNumberLegacy: 'Nomor kamar atau kode konfirmasi tidak valid',
  invalidMemberNumber: 'Nomor anggota tidak valid',
  invalidPhoneNumber: 'Nomor telepon tidak valid',
  requiredPhoneNumber: 'Nomor telepon wajib diisi',
  guestNameIsRequired: 'Nama tamu wajib diisi',
  roomNumberIsRequired: 'Nomor Kamar wajib diisi',
  roomNumberIsRequiredLegacy: 'Nomor Kamar atau Kode konfirmasi wajib diisi',
  roomOrReservationNumberIsRequired:
    'Nomor kamar atau nomor konfirmasi wajib diisi',
  cardNumberIncomplete: 'Nomor Kartu Tidak Lengkap',
  lastNameValidationError: 'Nama belakang wajib diisi',
  isReqd: 'wajib diisi',
  reservationCode: 'Nomor Reservasi/Konfirmasi',
  nonHotelGuest: 'Bukan Tamu Hotel',
  onPropertyGuest: 'Tamu di Properti',
  preArrivalGuest: 'Tamu Pra-Kedatangan',
  cardNumber: 'Nomor kartu',
  pmsValidationErrorMessage:
    'Nama belakang atau nomor kamar atau nomor konfirmasi tidak valid',
  pmsDateValidationErrorMessage:
    'Maaf! Tanggal pengalaman tidak berada di antara tanggal kedatangan dan keberangkatan Anda.',
  fullName: 'Nama Lengkap',
  checkout: 'Pembayaran',
  editParticipants: 'Edit Peserta',
  private: 'Privat',
  browseAllExperieces: 'Jelajahi semua pengalaman',
  payWithCreditCard: 'Bayar dengan Kartu Kredit',
  payWithRoomCharge: 'Bayar dengan Tagihan Kamar',
  payWithMemberCharge: 'Bayar dengan Tagihan Anggota',
  payWith: 'Bayar dengan',
  bookBulkErrorByCard:
    'Terjadi masalah saat mengonfirmasi pemesanan Anda. Kartu Anda tidak dikenakan biaya.',
  bookBulkErrorByRoomCharge: 'Nama belakang dan nomor kamar tidak valid.',
  bookBulkErrorByMemberCharge: 'Nama belakang dan nomor anggota tidak valid.',
  reviewCancellation: 'Tinjau Pembatalan',
  selectAReservationToCancel: 'Pilih reservasi untuk dibatalkan',
  confirmCancellation: 'Konfirmasi pembatalan',
  cancellable: 'Dapat dibatalkan',
  cancelled: 'Dibatalkan',
  deadlinePassed: 'Batas waktu terlewat',
  noCancellations: 'Tidak ada pembatalan',
  reviewReschedule: 'Reservasi Anda',
  selectAReservationToReschedule: 'Pilih reservasi untuk dijadwalkan ulang',
  confirmReservation: 'Konfirmasi reservasi',
  confirm: 'Konfirmasi',
  selectADateAndTime: 'Pilih tanggal dan waktu',
  noOtherSessionsAvailableForThisExperience:
    'Tidak ada sesi lain yang tersedia untuk pengalaman ini.',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'Reservasi ini tidak dapat dijadwalkan ulang lagi. Silakan kirim email ke {{brandEmail}}',
  thisReservationCannotBeRescheduled:
    'Reservasi ini tidak dapat dijadwalkan ulang',
  noTimesAvailable: 'Tidak ada waktu tersedia',
  noBookingsAvailable: 'Tidak ada pemesanan tersedia',
  youPaid: 'Anda membayar',
  refund: 'Pengembalian Dana',
  yourRefund: 'Pengembalian dana Anda',
  yourRefundWillBeProcessedToTheOriginalPayment:
    'Pengembalian dana Anda akan diproses ke pembayaran asli.',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    'Reservasi ini tidak dapat dibatalkan lagi. Silakan kirim email ke {{brandEmail}}',
  reservationCancelled: 'Reservasi dibatalkan',
  thisReservationCannotBeCancelled: 'Reservasi ini tidak dapat dibatalkan',
  thisReservationHasAlreadyBeenCancelled: 'Reservasi ini sudah dibatalkan',
  theHotel: 'Hotel',
  cancelling: 'Membatalkan',
  somethingWentWrong: 'Terjadi kesalahan',
  previouslyRefunded: 'Sebelumnya dikembalikan',
  remainingBalance: 'Sisa Saldo',
  notEnoughPoints: 'Poin tidak cukup',
  notEnoughPointsDescription:
    'Anda tidak memiliki cukup Poin World of Hyatt untuk menyelesaikan pembelian ini.',
  currentPointsBalance: 'Saldo poin saat ini: {{count, number}}',
  points: 'poin',
  pointsWithCount_one: '{{count, number}} poin',
  pointsWithCount_other: '{{count, number}} poin',
  payWithHyattPoints: 'Bayar dengan Poin Hyatt',
  pleaseSignIn: 'Silakan Masuk',
  worldOfHyattPoints: 'Poin World of Hyatt',
  bookBulkErrorByNotEnoughSeats:
    'Tidak cukup kursi tersedia untuk sesi ini. Silakan coba sesi lain.',
  phoneNumber: 'Nomor telepon',
  requestToBookConfirmationText: 'Email konfirmasi telah dikirim ke {{email}}',
  reservationRescheduled: 'Reservasi dijadwalkan ulang',
  yourReservationWasRescheduledTo: 'Reservasi Anda telah dijadwalkan ulang ke',
  viewExperiences: 'Lihat pengalaman',
  joinBook: 'Gabung & Pesan',
  signInBook: 'Masuk & Pesan',
  signAndJoin: 'Masuk atau Gabung untuk Memesan',
  signAndJoinDescription:
    'Pengalaman World of Hyatt FIND eksklusif untuk anggota World of Hyatt. Masuk atau gabung untuk memesan dan mendapatkan poin. Tidak ingin bergabung? Anda masih dapat memesan pengalaman non-eksklusif dengan menghapus Pengalaman World of Hyatt dari keranjang Anda.',
  promoOrFind: 'Kode Promo atau Kredit Find',
  hyattTermsAndConditions: 'Syarat & Ketentuan',
  hyattTermsAndConditionsAgreement:
    'Dengan mengonfirmasi pemesanan ini, saya menerima kebijakan pembatalan. Saya juga telah membaca dan mengakui penggunaan informasi pribadi saya sesuai dengan',
  hyattTermsAndConditionsLink: 'Kebijakan Privasi Hyatt',
  hyattWaiverText:
    'Dengan membeli pengalaman ini, saya menyetujui, memahami, dan mengakui, baik atas nama saya sendiri maupun atas nama setiap individu yang berpartisipasi dalam pengalaman yang dibeli oleh saya (jika ada), hal-hal berikut',
  hyattWaiverLink: 'pengabaian umum',
  priceDisclaimer: 'Termasuk biaya sebelum pajak',
  curatedRecommendations: 'Rekomendasi pilihan',
  moreExperiencesYouMightLike: 'Pengalaman lain yang mungkin Anda sukai',
  similarExperiencesAvailableToBookDirectly:
    'Pengalaman serupa tersedia untuk dipesan langsung',
  experiencesAvailableAroundYourBookingDate:
    'Pengalaman yang tersedia di sekitar tanggal pemesanan Anda',
  confirmationEmailSent:
    'Kami telah mengirim konfirmasi ke {{email}} dengan detail lebih lanjut.',
  youreBooked: 'Anda telah memesan',
  purchaserInformation: 'Informasi Pembeli',
  requiredFieldIndicator: '* menunjukkan bidang yang wajib diisi',
  resourceSelectionTitle: 'Pilih opsi Anda',
  resourceSelectionDescription:
    'Pilih satu opsi untuk setiap item dalam pemesanan Anda.',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: 'Pilih {{attributeName}}',
  resourceValueSoldOut: '{{label}} (habis terjual)',
  resourceValueUnavailableWith: '{{label}} (tidak tersedia dengan {{picks}})',
  resourceOptionsUnavailable:
    'Kami tidak dapat memuat opsi untuk waktu ini. Silakan coba lagi.',
  resourceOptionsRetry: 'Coba lagi',
  changeResourceSelections: 'Ubah pilihan Anda',
};
